/**************************************************
 * original
 **************************************************/
const midwest = {
  common: {},
  top: {},
  itemList: {},
  itemDetail: {},
  cart: {},
  shop: {},
  contact: {},
  login: {},
  brandlist: {},
  about: {},
  recruit: {},
};

/**
 * ページ上部のトピックスの表示制御
 */
midwest.common.displayHeaderInformation = function() {
  const swithSpeed = 1000;
  const stopTime = 3000;

  // 他コンテンツの高さへの影響があるため、bodyにフラグ用のclassを付与
  $('body').addClass('is-header-topics');
  
  // Swiper初期化
  const swiper = new Swiper('.js-information-swiper', {
    loop: document.querySelectorAll('.js-information-swiper .swiper-slide').length > 1,
    speed: swithSpeed,
    autoplay: {
      delay: stopTime,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    pagination: false,
    navigation: false,
  });
};

/**
 * メインコンテンツがヘッダーに重なる場合の処理
 */
midwest.common.fixContentTop = function() {
  // ヘッダーの高さを取得
  const headerHeight = $('.section-header').outerHeight();
  // お知らせがあれば、お知らせの高さを取得
  const topicsHeight = $('.js-header-topics-container').outerHeight();
  //　合計した高さ
  // const totalOffsetHeight = headerHeight + topicsHeight;
  const totalOffsetHeight = headerHeight;

  // メインコンテンツを画面上部にくっつける
  $('#MainContent').css('margin-top',`-${totalOffsetHeight}px`);
};

/**
 * トグルのパネル表示
 */
midwest.common.setupTogglePanel = function() {
  const openClass = 'is-open';//アクティブclass

  $('.js-panel-button').each(function(){
    //ボタンクリックで、要素を展開
    $(this).on( 'click',function(){
      $(this).parents('.js-panel-container').toggleClass(openClass);
      $('body').toggleClass('is-panel-open overflow-hidden-desktop');
    });
  
    //オーバーレイ・閉じるボタンクリックで、閉じる
    $('.js-panel-overlay, .js-panel-close').on( 'click',function(){
      $(this).parents('.js-panel-container').removeClass(openClass);
      $('body').removeClass( 'is-panel-open overflow-hidden-desktop');
    });
  });
};

/**
 * ハンバーガーメニュー内の上部余白調整
 */
midwest.common.hamburgerMargin = function() {
  const header = 'header';
  const content = '.js-header-panel-content';
  const headerHeight = $(header).outerHeight();
  const headerDurationTime = 500;// ヘッダーが表示されるまでのtransition-durationの秒数
  
  // 初回読み込み時：ヘッダーの画面内上部からの位置を取得
  let headerTop = $(header)[0].getBoundingClientRect().top;
  // ヘッダーの高さ + 表示上の位置に応じて、パネルの上パディングを調整
  $(content).css('padding-top',headerHeight+headerTop);

  // スクロール時にも、画面内でのヘッダー位置に応じてパディングを動的に調整
  $(window).on("scroll", function () {
    setTimeout(function(){
      headerTop = $(header)[0].getBoundingClientRect().top;
      $(content).css('padding-top',headerHeight+headerTop);
    },headerDurationTime);
  });
};

/**
 * アコーディオンメニュー
 */
midwest.common.accordion = function() {
  function shouldProcess($target) {
    // スマホ専用：ボタンに `--sp` クラスがあり、端末がスマホのときのみ
    const isSP = $target.hasClass('js-accordion-button--sp') && illm.common.isSmartphone();
    // モバイル専用：ボタンに `--mobile` クラスがあり、端末がスマホ or タブレットのときのみ
    const isMobile = $target.hasClass('js-accordion-button--mobile') && illm.common.isMobile();
    // 制限なし：どちらのクラスも持たない（すべての端末が対象）
    const isDefault = !$target.hasClass('js-accordion-button--sp') && !$target.hasClass('js-accordion-button--mobile');
    // 上記いずれかの条件を満たす場合のみ処理を実行
    return isSP || isMobile || isDefault;
  }

  //ページ読み込み時、is-openが付いてたらオープン状態
  $('.js-accordion-button').each(function () {
    const $this = $(this);
    if (shouldProcess($this) && $this.hasClass('is-open')) {
      $this.siblings('.js-accordion-contents').slideToggle();
    }
  });

  // クリックしたらアコーディオンを開閉
  $('.js-accordion-button').on('click', function () {
    const $this = $(this);
    if (shouldProcess($this)) {
      $this.siblings('.js-accordion-contents').slideToggle();
      $this.toggleClass('is-open');
    }
  });
};

/**
 * タブ切り替え
 */
midwest.common.tabswitch = function() {
  const activeClass = 'is-active';//アクティブclass

  $('.js-tab__button').on( 'click', function() {
    const tabContainer = $(this).parents( '.js-tab__container' );// タブ要素を包括する全体要素
    //一旦リセットして、該当のタブをアクティブ化
    tabContainer.find( '.js-tab__button, .js-tab__content' ).removeClass( activeClass );
    $(this).addClass(activeClass);
  
    //該当コンテンツをアクティブ化
    const targetTabIndex = tabContainer.find( '.js-tab__button' ).index(this);
    tabContainer.find( '.js-tab__content' ).eq( targetTabIndex ).addClass( activeClass );
  });
};

/*
 * 「新作」アイコンの表示制御（発売日から30日以内なら表示）
 * @param date サーバー時間
 */
midwest.common.newicon = function(date) {
  const newBadgePeriodDays = 30;//newアイコンを表示しておく期間（日）
  const hiddenClass = 'hidden';//非表示class名
  const nowDate = date;//現在日時

  if($('[data-release-date]').length > 0){
    // メタフィールドが発売日の場合
    $('.js-new-icon').each(function(){
      // 発売日を取得
      const releaseDate = new Date($(this).data().releaseDate);// 例：{releaseDate: '2025-12-31'}
      if(isNaN(releaseDate.getTime())){
        return;// 無効な日付ならスキップ
      }
      
      // 発売日の開始時刻を 0:00:00.000 に設定
      releaseDate.setHours(0, 0, 0, 0);

      // 表示終了日時 = 発売日からnewBadgePeriodDays日後の23:59:59.999
      const displayEndDate = illm.common.dateUtil.getEndDateByDays(releaseDate, newBadgePeriodDays);

      // 現在時刻が表示期間内ならアイコンを表示
      if (illm.common.dateUtil.isWithinRange(nowDate, releaseDate, displayEndDate)) {
        $(this).removeClass(hiddenClass);
      }
    });
  }/*else if($('[data-end-date]').length > 0){
    // メタフィールドが期限日の場合
    $( '.js-new-icon' ).each(function(){
      // 表示期限日を取得
      const newEndDate = new Date($(this).data().endDate);// 例：{newDays: '2025-12-31'}
      newEndDate.setHours(23, 59, 59, 999); // 表示期限は23時59分59秒999ミリ秒まで
      const newEndDateTime = newEndDate.getTime();//UNIX時間に変換
      if(isNaN(newEndDate)){
        return;
      }
      //期限日以内であれば、「新作」アイコンを表示
      if(currentTime <= newEndDateTime){
        $(this).removeClass(hiddenClass);
      }
    });
  }*/
};

/**
 * collection/productのMOVIEスライダー
 */
midwest.common.movieSlider = function() {
  const slideTarget = document.querySelector('.js-subpage-movie-swiper');//対象のスライド
  
  const movieSwiper = new Swiper(slideTarget, {
    slidesPerView: 'auto',
    freeMode: true,
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      750: {
        scrollbar: {
          el: '.swiper-scrollbar',//PCのみスクロールバー表示
        },
      }
    }
  });
};

/**
 * NEW / RECOMMENDのスクロールバー表示処理（iPhoneでも常に表示させるため）
 */
midwest.top.initSimpleBarMobile = function() {
  // 自動初期化を無効化（CDN版で自動初期化される場合）
  SimpleBar.defaultOptions.autoInitialize = false;

  function initScrollContainers() {
    const scrollContainers = document.querySelectorAll('.js-sp-scrollbar');
    scrollContainers.forEach( scrollContainer => {
      // 既に SimpleBar が初期化されていれば破棄
      if (scrollContainer.SimpleBar) {
        scrollContainer.SimpleBar.unMount();
        scrollContainer.removeAttribute('data-simplebar');
      }

      // スマホ幅の場合のみ有効化
      if (illm.common.isSmartphone()) {
        scrollContainer.setAttribute('data-simplebar', '');
        new SimpleBar(scrollContainer);
      }
    });
  }

  // 初回実行
  initScrollContainers();

  // 画面サイズ変更時にも再判定
  window.addEventListener('resize', initScrollContainers);
}

/*
 * スクロールインジケーター
 */
midwest.common.scrollIndicator = function() { 
  const scrollPrompt = document.querySelector('.js-scroll-indicator');// スクロールを促す要素を取得
  const scrolledClass = 'is-scrolled';// スクロールされたら付与されるclass
  let ticking = false; // requestAnimationFrame の制御用フラグ
  let isHidden = false; // 現在の表示状態を保持

  // スクロールイベントを監視
  window.addEventListener('scroll', () => {
    // 多発するscrollイベントを間引く
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const scrollPosition = window.scrollY; // 現在のスクロール量(px)
        // スクロールが100pxを超えたら非表示にする
        if (scrollPosition > 100 && !isHidden) {
          scrollPrompt.classList.add(scrolledClass);
          isHidden = true; // 状態を更新
        } 
        // 上部に戻ったら再表示
        else if (scrollPosition <= 100 && isHidden) {
          scrollPrompt.classList.remove(scrolledClass);
          isHidden = false; // 状態を更新
        }
        ticking = false; // requestAnimationFrame制御解除
      });
      ticking = true;
    }
  });
};


/**
 * メインビジュアルのスライダー
 */
midwest.top.mainvisual = function() {
  const slideAutoplay = Boolean($('#illm-slide_autoplay').attr('date-info'));//自動再生: true
  const slideAutoplaySpeed = parseInt($('#illm-slide_autoplay_speed').attr('date-info'));//自動再生時の静止時間: 4000ms
  const slideSpeed = parseInt($('#illm-slide_speed').attr('date-info'));//スライドアニメーションの速度: 600ms
  const slideArrow = Boolean($('#illm-slide_arrow').attr('date-info'));//左右矢印の表示: true
  const slideDot = Boolean($('#illm-slide_dot').attr('date-info'));//ドットの表示: true
  const slideTarget = document.querySelector('.js-home-visual-swiper');//対象のスライド
  
  if (!slideTarget.swiper) {
    // Swiper初期化
    const homeVisualSwiper = new Swiper( slideTarget, {
      parallax: true, //パララックス
      slidesPerView: 1,
      speed: slideSpeed,
      loopAdditionalSlides: 1,
      // 自動再生
      autoplay: slideAutoplay ? {
        delay: slideAutoplaySpeed,
      } : false,
      allowTouchMove: true,
      loop: true,
      // ナビゲーション（矢印）
      navigation: slideArrow ? {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      } : false,
      // ページネーション（ドット）
      pagination: slideDot ? {
        el: ".swiper-pagination",
        clickable: true,
      } : false,
    });
  }else{
    // スライダー要素に変更があった場合、更新
    slideTarget.swiper.loopDestroy();
    slideTarget.swiper.loopCreate();
    slideTarget.swiper.update();
  }
};

/*
 * ヘッダーの文字色の変更
 */
midwest.top.controlHeaderColor = function() {
  //要素の高さを取得するため、画像読み込み後に実行
  $(window).on('load', function(){
    const whiteHeaderClass = "js-transparent-header"; //スクロール中のclass
    const headerHeight = $('sticky-header').outerHeight() + $('.js-header-topics-container').outerHeight();//ヘッダーとニュースを含む高さ
    
    //スクロール
    $(window).on("scroll", function () {
      if ($(this).scrollTop() <= headerHeight) {
        //最上部のときだけ、ヘッダー透過
        $('body').addClass(whiteHeaderClass);
      }else{
        $('body').removeClass(whiteHeaderClass);
      }
    });
  });
};

/**
 * RECOMMEND のスライダー
 */
midwest.top.collectionSlider = function() {
  const slideTargets = document.querySelectorAll('.js-collection-swiper');//対象のスライド
  
  slideTargets.forEach(function(swiperElement) {
    const isSmartphone = illm.common.isSmartphone();
    const isRecommendCollection = swiperElement.closest('.recommend-container') !== null;
    // PCのRECOMMENDのみスライダー
    if(!isSmartphone && isRecommendCollection){
      if (!swiperElement.swiper) {
        const colletionSwiper = new Swiper(swiperElement, {
          slidesPerView: 4,//スライドの横幅
          speed: 800,
          scrollbar: {
            el: '.swiper-scrollbar',
          },
          freeMode: {
            enabled: false,
            momentum: true,
          },
          breakpoints: {
            750: {
              spaceBetween: 30,
              navigation: {                
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            }
          }
        });
      }else{
      // スライダー要素に変更があった場合、更新
        if (swiperElement.swiper) {
          swiperElement.swiper.update();
        }
      }
    }
  });
};

/**
 * TOPのMOVIEスライダー
 */
/*// グローバルにプレイヤーを保存するためのオブジェクト
const topMoviePlayers = {};

// YouTube API 準備
function onYouTubeIframeAPIReady() {
  console.log('onYouTubeIframeAPIReady');
  
  document.querySelectorAll('.js-home-movie-swiper iframe').forEach((iframe, index) => {
    // src から videoId を取り出す
    const match = iframe.src.match(/embed\/([^?]+)/);
    const videoId = match ? match[1] : null;
    // 取れなければスキップ
    if (!videoId){
      return; 
    }
    console.log(videoId);
    // 自動再生
    topMoviePlayers[videoId] = new YT.Player(iframe, {
      videoId: videoId,
      playerVars: {
        autoplay: 0,
        mute: 1, // 自動再生したいならミュート推奨
        controls: 1,
        modestbranding: 1
      },
      events: {
        onReady: function(event) {
          // 初期化が完了したら再生可能
          event.target.playVideo(); 
        }
      }
    });
  });
}

// グローバルにプレイヤー保持
let testPlayer;

// YouTube IFrame API が読み込まれたら呼ばれる
function onYouTubeIframeAPIReady() {
  const iframe = document.querySelectorAll('.js-home-movie-swiper iframe')[0];
  if (!iframe) return;

  console.log('自動再生');

  testPlayer = new YT.Player(iframe, {
    playerVars: {
      autoplay: 1, // 自動再生
      mute: 1,     // ミュート必須
      controls: 1
    },
    events: {
      onReady: function(event) {
        event.target.playVideo(); // 再生
      }
    }
  });
}*/

midwest.top.movieSlider = function() {
  const movieSlideTarget = document.querySelector('.js-home-movie-swiper');//対象のスライド
  let isMovieCenter = true;// 中央に表示
  let isMovieLoop = true;// ループ
  let movieMargin = 20;// 左右の余白
  
  if (!movieSlideTarget.swiper) {
    const movieSwiper = new Swiper(movieSlideTarget, {
      slidesPerView: 'auto',//スライドの横幅
      centeredSlides: isMovieCenter,
      spaceBetween: movieMargin,
      loop: isMovieLoop,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }else{
    // スライダー要素に変更があった場合、更新
    movieSlideTarget.swiper.loopDestroy();
    movieSlideTarget.swiper.loopCreate();
    movieSlideTarget.swiper.update();
  }

  /*
  console.log(movieSwiper);

  // 後からイベントを追加
  movieSwiper.on('slideChange', function() {
    console.log(movieSwiper);
    handleSlideChange();
  });

  // 表示中のスライドを再生
  function handleSlideChange() {
    const activeSlide = movieSwiper.slides[movieSwiper.activeIndex];
    // スライド内の iframe を取得
    const iframe = activeSlide.querySelector('iframe');
    // iframe がなければスキップ
    if (!iframe) {
      return;
     }
    // iframe の src から videoId を取得
    const match = iframe.src.match(/embed\/([^?]+)/);
    const videoId = match ? match[1] : null;

    // 他のスライドは停止
    for (let id in topMoviePlayers) {
      if (id !== videoId && typeof topMoviePlayers[id].pauseVideo === 'function') {
        topMoviePlayers[id].pauseVideo();
      }
    }

    // 表示中のスライドだけ再生
    if (topMoviePlayers[videoId] && typeof topMoviePlayers[videoId].playVideo === 'function') {
      topMoviePlayers[videoId].playVideo();
    }

  }*/
};

/**
 * ALL / MEN / WOMEN カテゴリの切り替え
 */
midwest.top.switchCategory = function() {
  const activeClass = 'is-active';//アクティブclass
  const cookieName = 'category_filter';
  const buttons = '.js-category-nav button';//カテゴリのボタン
  const cookieExpireHours = 1;// Cookie保存期間（日数）
  const allCategoryName = 'all';//「ALL」のdata-categoryの値
  let categoryName = '';

  //ページ読み込み時
  let savedCategory = illm.common.getCookie(cookieName);
  if (savedCategory) {
    // Cookieがあれば対象のボタンをアクティブに
    $(buttons).each(function () {
      const $btn = $(this);
      $btn.toggleClass('is-active', $btn.data('category') === savedCategory);
    });
  }else {
    // Cookieがなければアクティブ状態のボタンからカテゴリを取得し、その値をcookieに保存
    categoryName = $(`${buttons}.is-active`).data('category');
    illm.common.setCookie(cookieName, categoryName, {days: cookieExpireHours});      
  }

  // コンテンツをカテゴリごとに切り替え
  midwest.top.switchCategoryContents(savedCategory);

  // ボタンクリック時
  $(buttons).on('click', function(){
    // Cookieを取得
    savedCategory = illm.common.getCookie(cookieName);
    
    // Cookieに保存（1日）
    categoryName = $(this).data('category');
    // 一旦すべてのボタンのアクティブ状態を解除
    $(buttons).removeClass(activeClass);
    
    // 選択されているカテゴリを再度クリックすると、ALLが適用される
    if(savedCategory === categoryName){
      illm.common.setCookie(cookieName, allCategoryName, {days: cookieExpireHours});      
      $(`${buttons}[data-category="${allCategoryName}"]`).addClass(activeClass);
      
    // 別のカテゴリであれば、Cookie切り替え
    }else{
      illm.common.setCookie(cookieName, categoryName, {days: cookieExpireHours});      
      $(this).addClass(activeClass);
    }

    // Cookieを取得
    savedCategory = illm.common.getCookie(cookieName);
    // コンテンツをカテゴリごとに切り替え
    midwest.top.switchCategoryContents(savedCategory);
    
  });
};

/**
 * コンテンツをカテゴリごとに切り替え
 * @param {string} categoryName - 選択されているカテゴリ
 */
midwest.top.switchCategoryContents = function(categoryName) {
  const allCategoryName = 'all';//「ALL」のdata-categoryの値
  const hiddenClass = 'js-hidden';// hiddenクラス
  const sliderClass = 'js-slider-item';// 各slider画像のクラス
  const filterParam = '?filter.v.price.gte=&filter.v.price.lte=&filter.p.m.custom.product_gender=';// collectionページの絞り込みパラメータ

  // console.log(`現状フィルター：${categoryName}`);
  if(categoryName){
    // 文字列を比較するため、小文字に変換
    categoryName = categoryName.toLowerCase();
  }else {
    // 選択されているカテゴリがない場合は、「ALL」とする
    categoryName = allCategoryName;
  }
  
  // コンテンツの表示切替
  if($('.js-gender-item').length > 0){
    // カテゴリがALLならすべて表示
    if(categoryName === allCategoryName){
      // スライダーにはswiper-slideクラスを付与
      $('.js-gender-item').removeClass(hiddenClass);
      $('.js-gender-item:not(.js-hidden).' + sliderClass).addClass('swiper-slide');
      
    }else {
      // コンテンツごとに処理
      $('.js-gender-item').each(function() {
        // 文字列を比較するため、小文字に変換
        const thisCategoryData = $(this).data('category') || '';
        const thisCategoryName = thisCategoryData.toLowerCase();
        
        // 「ALL」コンテンツは、カテゴリに関わらず表示
        if(thisCategoryName === allCategoryName){
          $(this).removeClass(hiddenClass);
          
        // 選択したカテゴリに一致するコンテンツを表示（MEN選択中はMENの商品・記事を表示）
        }else if(thisCategoryName === categoryName){
          $(this).removeClass(hiddenClass);
        }else{
          $(this).removeClass('swiper-slide');
          $(this).addClass(hiddenClass);
        }
        // スライダーにはswiper-slideクラスを付与
        if(!$(this).hasClass(hiddenClass) && $(this).hasClass(sliderClass)){
          // console.log(`swiper-slide:${$(this)}`);
          $(this).addClass('swiper-slide');
        }
      });
    }
    
    // メインビジュアルのスライダー更新
    if($('.js-home-visual-swiper').length){
      midwest.top.mainvisual();
    }

    // MOVIEのスライダー更新
    if($('.js-home-movie-swiper').length){
      midwest.top.movieSlider();
    }
  }

  /* ブログの表示切替
   * ソース上にALL、MEN、WOMENそれぞれ出力しているので、対応するカテゴリのみを表示
   */
  // 一旦すべて非表示
  $('.js-gender-blog').addClass(hiddenClass);
  // 対応するカテゴリ記事のみ表示
  $('.js-gender-blog').each(function(){
    const thisCategoryData = $(this).data('category') || '';
    const thisCategoryName = thisCategoryData.toLowerCase();
    if(thisCategoryName == categoryName) {
      $(this).removeClass(hiddenClass);
    }
  });

  // NEW ITEMの表示切替
  if($('#newitem-container').length > 0){
    let newitemUrl = '';
    // カテゴリに応じてURLを生成
    if(categoryName === allCategoryName){
      newitemUrl = `/collections/new?view=ajax`;
    }else {
      newitemUrl = `/collections/newitem_${categoryName}?view=ajax`;
    }
    // AjaxでNEW ITEM用のHTMLを取得して差し替え
    $.ajax({
      url: newitemUrl, // viewテンプレートを使う（後述）
      success: function(data) {
        $('#newitem-container').html(data);
        // NEWアイコン表示処理
        illm.common.getServerDate().then( date => {
          midwest.common.newicon(date);
        });
        // スクロールバー表示処理（iPhoneでも常に表示させるため）
        if($('.js-sp-scrollbar').length){
          midwest.top.initSimpleBarMobile();
        }
      }
    });

    // VIEW MOREの表示切替
    // 一旦すべて非表示
    $('.js-gender-item-button').addClass(hiddenClass);
    // 対応するVIEW MOREボタンのみ表示
    $('.js-gender-item-button').each(function(){
      const thisCategoryData = $(this).data('category') || '';
      const thisCategoryName = thisCategoryData.toLowerCase();
      if(thisCategoryName == categoryName) {
        $(this).removeClass(hiddenClass);
      }
    });

  }

  // recommendの表示切替
  if($('#recommend-container').length > 0){
    let recommendUrl = '';
    if(categoryName === allCategoryName){
      recommendUrl = `/collections/recommend?view=ajax`;
    }else {
      recommendUrl = `/collections/recommend_${categoryName}?view=ajax`;
    }
    // Ajaxでrecommend用のHTMLを取得して差し替え
    $.ajax({
      url: recommendUrl, // viewテンプレートを使う（後述）
      success: function(data) {
        $('#recommend-container').html(data);
        // NEWアイコン表示処理
        illm.common.getServerDate().then( date => {
          midwest.common.newicon(date);
        });
        // スクロールバー表示処理（iPhoneでも常に表示させるため）
        if($('.js-sp-scrollbar').length){
          midwest.top.initSimpleBarMobile();
        }
        // スライダー更新
        midwest.top.collectionSlider();
      }
    });
  }
  
  // リンク先をMEN、WOMENのコレクションページに遷移
  $('.js-gender-link').each(function(){
    let collectionLinkHref;
    // data-hrefの値(元リンク先)
    collectionLinkHref = $(this).data('href');
    if(categoryName === allCategoryName){
      // ALLの場合、絞り込みパラメータをリセット
      $(this).attr('href',`${collectionLinkHref}`)
    } else {
      // フィルター名が大文字なので大文字に変換してから、パラメータ付きURLをセット
      const upperCategoryName = categoryName.toUpperCase();
      $(this).attr('href',`${collectionLinkHref}${filterParam}${upperCategoryName}`)
    }
  });

};

/**
 * 商品画像の拡大処理
 */
midwest.itemDetail.zoomProductImages = function(){
  const productImage = '.js-product-slider .product__media img';//商品画像
  const activeClass = 'is-active';//アクティブclass
  let clickCount = 0; //商品画像をクリックした回数
  let scrollPosition = 0; //スクロール位置を保持する変数

  // bodyの開始タグの直下に拡大用の空のDOMを生成
  const html = `
    <div class="js-image-zoom__container">
      <div class="js-image-zoom__close"></div>
      <div class="js-image-zoom-wrap">
        <ul class="js-image-zoom"></ul>
        <div class="js-image-zoom-active"></div>
      </div>
    </div>
  `;
  $('body').prepend(html);

  //商品画像をクリックしたら
  $( productImage ).on( 'click',function(){

    //1度目のクリックであれば、拡大用ののDOM生成　※2度目以降は作る必要がないのでスルー
    if (clickCount === 0) {
      $( productImage ).each(function () {
        // 新しいli要素を作成し、img要素を追加
        const productImg = $( '<li>' ).append( $( this ).clone() );
        //あらかじめ用意してあるズーム用の要素に商品画像のimgを追加
        $( '.js-image-zoom' ).append( productImg );
      });

      //他のサムネイル画像をクリックしたら
      $( `.js-image-zoom li:not(.${activeClass})` ).on( 'click', function(){
        //アクティブクラスを初期化
        $( '.js-image-zoom li' ).removeClass( activeClass );
        //アクティブクラスを付与
        $( this ).addClass(activeClass);
        //拡大画像を初期化してから、切り替える
        //$( '.js-image-zoom-active' ).html( '' ).append( $( this ).clone() );
      });

      //クリック回数のカウント
      clickCount++;
    }

    //アクティブclassを付与して、対象の画像を拡大する
    /*$( '.js-image-zoom li' ).removeClass( activeClass );//class一旦削除
    const activeIndex = $(this).index(productImage); //インデックス取得
    $( '.js-image-zoom li' ).eq( activeIndex ).addClass( activeClass );//class付与
    //拡大用のタグを一度空にしてからく拡大するimgを追加
    $( '.js-image-zoom-active' ).html( '' ).append( $( this ).clone() );*/

    //現在地を記憶して、ページ上部に移動
    //scrollPosition = $(window).scrollTop();
    //$( 'html, body' ).scrollTop( 0 );

    // ポップアップ上部に移動
    $( '.js-image-zoom__container' ).scrollTop( 0 );
    //拡大画像を表示
    $( '.js-image-zoom__container' ).addClass( 'is-open' );    
    //サイト全体のスクロールを無効化
    $('body').addClass('overflow-hidden-desktop');

  });

  //閉じるボタンをクリック時
  $( '.js-image-zoom__close' ).on( 'click', function(){
    //拡大画像を非表示
    $( '.js-image-zoom__container' ).removeClass( 'is-open' );
    //サイト全体のスクロールを有効化
    $('body').removeClass('overflow-hidden-desktop');
  });
};

/**
 * サイズの単位切り替え
 */
midwest.itemDetail.toggleSizeUnit = function(){
  const activeClass = 'is-active';//アクティブclass

  // cm、inchの切り替えたら
  $('.js-size-toggle').on('click', function () {
    // アクティブラスを付与して、cssで見た目を制御
    $(this).toggleClass(activeClass);
    const isInch = $(this).hasClass(activeClass);
    
    // inch表示
    if(isInch){
      $('.js-size-list td[data-cm]').each(function(){
        // inch表示不可の場合、表示しない
        if ($(this).data('not-convert') !== undefined) {
          $(this).text('-');
        }else{
          // cmの数値を取得（小数点以下もそのまま保持）
          const sizeCm = parseFloat($(this).text());
          if(sizeCm){
            // inchに変換（小数点第2位を四捨五入）して、表示
            let sizeInch = sizeCm / 2.54;
            sizeInch = sizeInch.toFixed(1);
            $(this).text(sizeInch);
          }else{
            // cmの値が数値でない場合は、空欄
            $(this).text('-');
          }
        }
      });
    // cm表示
    }else{
      $('.js-size-list td[data-cm]').each(function(){
        // data-cmの値をそのまま表示
        $(this).text($(this).data().cm);
      });
    }
  });
};

/**
 * RECOMMEND / COLLECTIONの表示を検知
 */
midwest.itemDetail.observeRecommendSlider = function() {
   const target = document.querySelector('.related-products');
   // 更新を検知する要素がなければ処理終了
   if (!target){
     return;
   }
   const observer = new MutationObserver(function (mutationsList, observer) {
    // RECOMMEND / COLLECTIONのスライダー
    midwest.itemDetail.recommendSlider();
   });
   observer.observe(target, {
     childList: true,
     subtree: true
   });
};

/**
 * RECOMMEND / COLLECTIONのスライダー
 */
midwest.itemDetail.recommendSlider = function() {
  // 可変にしたい値を変数化
  const swiperSpeed = 800;
  const pcBreakpoint = illm.common.breakpoint.pc;//PCのブレークポイント
  const swiperSlides = 4;
  const swiperSpace = 30;

  // 対象のスライド
  const slideTargets = document.querySelectorAll('.js-product-recommend-swiper');
  // スライドの数分処理
  slideTargets.forEach(function(swiperElement) {
    if (!swiperElement.swiper) {
      const recommendSwiper = new Swiper(swiperElement, {
        slidesPerView: 'auto',
        speed: swiperSpeed,
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        freeMode: {
          enabled: false,
          momentum: true,
        },
        breakpoints: {
          [pcBreakpoint]: {
            slidesPerView: swiperSlides,
            spaceBetween: swiperSpace,
            navigation: {                
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          }
        }
      });
      // swiper初期化後に表示
      swiperElement.style.display = 'block';
    }
  });
};

/**
 * 店舗在庫のボタン切り替え
 */
midwest.itemDetail.updateStoreStockButton = function() {
  // product.variants から取得したデータは Liquid で <script> タグ内に `allVariantsData` として定義
  const $storeStockButton = $('#store-stock-button');
  const $productForm = $('form[action="/cart/add"]');
  // const baseUrl = 'https://store-midwest-member.com/stock/list?t=4e71881ce3e116d0&SCD=';
  // 店舗在庫連携用URL
  const baseUrl = document.getElementById('store_stock_url').value;//セクションで設定

  // ボタンまたはフォームが見つからない場合は処理を中断
  if (!$storeStockButton.length || !$productForm.length) {
    return;
  }

  // バリエーション変更時
  $productForm.on('change', 'select[name="id"], input[name="id"]', function() {
    const selectedVariantId = $(this).val();

    // 選択されたバリエーションのIDを使って、allVariantsDataから対応するバーコード（商品マスタ上の）を探す
    const selectedVariant = allVariantsData.find(variant => String(variant.id) === String(selectedVariantId));

    if (selectedVariant && selectedVariant.barcode) {
      // バーコードがある場合
      $storeStockButton.attr('href', baseUrl + selectedVariant.barcode);
      $storeStockButton.show(); // ボタンを表示
    } else {
      // バーコードがない場合
      $storeStockButton.hide(); // ボタンを非表示
      // 必要に応じて、hrefも更新（例: # にするなど）
      $storeStockButton.attr('href', '#');
    }
  });

  // 初期ロード時にもバーコードの有無を確認し、ボタンの表示を調整
  const initialSelectedVariantId = $productForm.find('select[name="id"], input[name="id"]').val();
  const initialSelectedVariant = allVariantsData.find(variant => String(variant.id) === String(initialSelectedVariantId));

  if (initialSelectedVariant && initialSelectedVariant.barcode) {
    $storeStockButton.attr('href', baseUrl + initialSelectedVariant.barcode);
    $storeStockButton.show();
  } else {
    $storeStockButton.hide();
    $storeStockButton.attr('href', '#');
  }
};


/**
 * ログイン後のページ遷移の制御
 */
midwest.login.handleLoginRedirect = function() {
  const urlParams = new URLSearchParams(window.location.search);// クエリパラメータを取得
  const returnTo = urlParams.get('return_to');// ログイン後のリダイレクト先を示す return_to パラメータを取得
  
  if (returnTo) {
    // 大文字・小文字を区別しない判定のため小文字化
    const lowerReturnTo = returnTo.toLowerCase();
  
    // 遷移元のURL（直前にいたページ）を取得。空文字なら''にフォールバック
    const referrer = document.referrer || '';
  
    // return_to に "product" が含まれている場合（商品ページから来た場合）
    if (lowerReturnTo.indexOf('product') !== -1) {
      // 遷移元が商品ページかチェック
      if (referrer.includes('/products/')) {
        // hidden input[name="return_url"] 要素を取得
        const returnInput = document.querySelector('input[name="return_url"]');
        if (returnInput) {
          // referrerをURLオブジェクトに変換し、パスとクエリのみ取得してセット
          const productUrl = new URL(referrer);
          returnInput.value = productUrl.pathname + productUrl.search;
        }
      }
    }
    // return_to に "cart" が含まれている場合（カートページから来た場合）
    else if (lowerReturnTo.indexOf('cart') !== -1) {
      // 遷移元がカートページかをチェック
      if (referrer.includes('/cart')) {
        const returnInput = document.querySelector('input[name="return_url"]');
        if (returnInput) {
          const cartUrl = new URL(referrer);
          // カートのパス＋クエリをセット
          returnInput.value = cartUrl.pathname + cartUrl.search;
        }
      }
    }
  }
};

/**
 * 商品情報をお問い合わせフォームにセット
 */
midwest.contact.setFormProductInfo = function() {
  // URLからクエリパラメータを取得
  const queryParams = illm.common.getQueryParams();
  // パラメータから商品名、商品コードの値を取得
  const productName = queryParams['product_name'];
  const productCode = queryParams['product_code'];

  // パラメータが存在すれば
  if (productName || productCode) {
    let textToSet = '';
    if (productName) {
      textToSet += `商品名: ${decodeURIComponent(productName)}\n`;
    }
    if (productCode) {
      textToSet += `商品コード: ${decodeURIComponent(productCode)}`;
    }
    // フォームに商品名と商品コードをセット
    $('.js-contact-textarea').val(textToSet);
  }  
};

/**
 * ブランドリストの絞り込み
 */
midwest.brandlist.filter = function() {
  //キーワード検索の要素
  const allBrandSearchInputs = '#brandSearchInput, #brandSearchInput_men, #brandSearchInput_women';
  
  // A~Zにクリックイベントを設定
  $('.js-alphabet-nav button').click(function(event) {
    // 現在選択されているボタンのクラスを解除し、クリックされたボタンにクラスを追加
    $('.js-alphabet-nav button').removeClass('is-current');
    $(this).addClass('is-current');
    // デフォルトのリンク動作を防ぐ
    event.preventDefault();

    let searchFormInputVal;

    // アクティブなタブに応じて検索フォームの値を設定
    if($('.js-tab__button.is-active').text().trim() == 'MEN'){
      // MEN
      searchFormInputVal = $('#brandSearchInput_men').val();
    }else if($('.js-tab__button.is-active').text().trim() == 'WOMEN'){
      // WOMEN
      searchFormInputVal = $('#brandSearchInput_women').val();
    }else{
      // ALL
      searchFormInputVal = $('#brandSearchInput').val();
    }

    // 検索フォームに値が入ってたら、クリアして全ブランドを表示
    if(searchFormInputVal !== ""){
      $(allBrandSearchInputs).val(''); // 入力値を空にする
      $('.js-brand-list li').show(); // ブランド全表示
      $('.brand-list__content').show().removeClass('hidden');// 絞り込み表示を解除
    }
    
    // クリックしたボタンのdata-letter属性からターゲットのIDを取得
    const targetID = $(this).data('letter');
    if(targetID === 'all'){
      //ALLクリックしたら、すべて表示
      $('.brand-list__content').show().removeClass('hidden'); //絞り込み表示解除      
    }else{      
      // ターゲットのセクションを選択し、兄弟要素を非表示に
      $(`.initial-${targetID}`).show().siblings('.brand-list__content').hide();
    }
  });

  // ブランド検索フォームにフォーカスしたときの処理
  $(allBrandSearchInputs).focus(function() {
    // 'A~Z'ボタンの選択状態をリセット
    $('.js-alphabet-nav button').removeClass('is-current');
    if ($(this).val() === "") {
        // 入力値が空の場合、非表示になっている全てのブランドリストセクションを表示
        $('.brand-list__content').show();
    }
  });

  
  let debounceTimer;// デバウンス用のタイマーを格納する変数

  // 検索機能の処理
  $(allBrandSearchInputs).on('input', function() {
    const searchInput = $(this);

    // 以前のタイマーをクリア（リセット）
    clearTimeout(debounceTimer);

    /*
    * デバウンス処理: ユーザーの入力が止まってから検索を実行することで、
    * パフォーマンスを最適化し、不必要な処理を削減する。
    * 300msという遅延は、一般的なタイピング速度を考慮した妥当な時間。
    */
    debounceTimer = setTimeout(function() {
      const searchText = searchInput.val().toLowerCase(); // 入力された文字を取得して小文字に変換
      
      // 入力欄が空の場合は全てのリスト項目を表示
      if (searchText === "") {
        $('.js-brand-list li').show();
        $('.brand-list__content').show().removeClass('hidden');
      } else {
        // 入力値がある場合、全てのセクションを一時的に非表示にする
        $('.brand-list__content').addClass('hidden');

        // 各ブランドリスト項目を処理
        $('.js-brand-list li').each(function() {
          const listItemText = $(this).text().toLowerCase(); // 各リスト項目のテキストを小文字に変換
          
          // 入力された文字がリスト項目のテキストに部分一致するかチェック
          if (listItemText.indexOf(searchText) !== -1) {
            $(this).show(); // 一致する場合は表示
            // 一致した項目の親セクションを表示状態に戻す
            $(this).parents('.brand-list__content').removeClass('hidden');
          } else {
            $(this).hide(); // 一致しない場合は非表示
          }
        });
      }
    }, 300); // 300msの遅延（必要に応じて調整可能）
  });
  
  // タブ切り替え時に絞り込みをリセットする処理
  $('.js-tab__button').on('click', function() {
    // 全てのブランドリスト項目とセクションを表示
    $('.js-brand-list li').show();
    $('.brand-list__content').show().removeClass('hidden');

    // キーワード検索フォームの値を空にする
    $(allBrandSearchInputs).val('');
  });
};
 
/**
 * スクロール時のアニメーション処理
 */
midwest.about.scrollAnimation = function () {
  // .js-about-visual の中にある各セクションを取得
  const visualSections = document.querySelectorAll(".js-about-visual .js-about-section");

  // 固定・相対位置に切り替えるときのクラス名
  const fixedClass = "is-fixed";
  const relativeClass = "is-relative";
  const zoomClass = "is-zoom";

  // スクロールイベントの多重発火を防ぐためのフラグ
  let isScrolling = false;

  /**
   * 指定したセクションの画像に状態を適用する関数
   * @param {HTMLElement} el - セクション要素
   * @param {string} addClass - 追加するクラス
   */
  const setVisualState = (section, addClass) => {
    const aboutImageEl = section.querySelector(".js-about-image");
    if (!aboutImageEl) {
      return;
    };

    // クラスがまだ付いていないときだけ変更を加える
    if (!aboutImageEl.classList.contains(addClass)) {
      aboutImageEl.classList.remove(fixedClass, relativeClass, zoomClass);
      aboutImageEl.classList.add(addClass);
    }
  };

  /**
   * 画面内の各セクションの位置に応じて
   * 画像の表示状態（固定・相対・非表示）を更新
   */
  const updateVisualStates = () => {

    visualSections.forEach((section, index) => {
      const aboutImageEl = section.querySelector(".js-about-image");
      const windowHeight = aboutImageEl.offsetHeight;
      let nextTop;

      // 画像がなかったら処理終了
      if (!aboutImageEl) {
        return;
      }
      // このセクションの次のセクションを取得
      let nextSection = section.nextElementSibling;

      // 要素の画面上の位置とサイズを取得
      const sectionRect = section.getBoundingClientRect();
      // 画面の上端から要素の上端までの距離
      const sectionTop = sectionRect.top;
      // 画面の上端から要素の下端までの距離
      const sectionBottom = sectionRect.bottom;
      
      // 最後のセクションなら
      if (!nextSection && index === visualSections.length - 1) {
        // #MainContentの次のセクションを取得
        const wrapper = document.querySelector('#MainContent');
        if (wrapper !== null && wrapper !== undefined) {
          nextSection = wrapper.nextElementSibling;
          // 最後のセクションは相対位置にはせず、固定のまま
          nextTop = window.innerHeight + 1;
        }
      // それ以外のセクションなら
      }else{
        // 次のセクションの上端が画面の上からどれくらいの位置にあるか
        nextTop = nextSection.getBoundingClientRect().top;
      }
      
      // 次のセクションの上端が画面内に入ったら、現在のセクションを相対配置に //relativeClass translateY(100%)
      if (nextTop <= window.innerHeight) {
        setVisualState(section, relativeClass);
      // 自分のセクションの上端が画面の上端に到達したら、固定表示に
      // sectionTop が 0 に近づくと、要素が画面の上部に来たことを示します // fixed translateY(0)
      }else if (sectionTop <= 0) {
          setVisualState(section, fixedClass);
      // 自分のセクションの上端が、画面中央を過ぎたら、transformを解除
      }else if (sectionTop <= window.innerHeight / 2) {
        if (nextSection) {
          setVisualState(section, zoomClass);
        }
      // 自分がまだ画面に入ってきていない場合は、非表示に // relativeClass translateY(0)
      }else {
        setVisualState(section, zoomClass);
      }
    });
  };

  /**
   * オーバーレイの透過度（--overlay-opacity）をスクロール位置に応じて更新し、
   * 画像サイズを調整する
   */
  const updateOverlayOpacitiesAndScale = () => {
    // 画像スケールを計算するための定数
    // デバイスに応じて初期スケールを設定
    let initialImageScale;
    if (illm.common.isSmartphone()) {
        // スマホの場合
        initialImageScale = 0.55;
    } else {
        // PCの場合
        initialImageScale = 0.6;
    }
    const finalScale = 1.0;// スケールの最終値
    const scaleRange = finalScale - initialImageScale;// スケールの変動幅を計算
    const opacityMax = 0.5;// opacityの最大値

    const windowHeight = window.innerHeight;

    visualSections.forEach((section, index) => {
      const aboutImageEl = section.querySelector(".js-about-image");
      if (!aboutImageEl) {
        return;
      }
      // ページ全体に対するこのセクションの上端位置
      const sectionTopInPage = section.getBoundingClientRect().top + window.scrollY;
      const scrollTop = window.scrollY;
      let scrollInSection;
      
      // セクションの中でどれくらいスクロールされたか（負値にならない）
      if (index > 0) {
        // 最初以外のセクションは、画面中央を過ぎたら
        scrollInSection = scrollTop - (sectionTopInPage - windowHeight / 2);
      }else{
        // 最初のセクションは、テキストが表示されるまで
        scrollInSection = scrollTop - sectionTopInPage;
      }

      // 0〜1 に正規化されたスクロール進捗
      const progress = Math.min(Math.max(scrollInSection / windowHeight, 0), 1);

      // 最初のセクション（indexが0）以外にのみスケールを適用
      if (index > 0) {
          // 画像のスケールを100%にアニメーションさせる
          const scale = initialImageScale + progress * scaleRange;
          // CSSの transform: scale() を設定
          aboutImageEl.style.setProperty("--image-scale", scale);
      } else {
          // 最初のセクションはスケールをリセット
          aboutImageEl.style.setProperty("--image-scale", 1);         
      }

      // opacityを適用するための新しい進捗を計算
      const opacityProgressStart = (0.8 - initialImageScale) / (1.0 - initialImageScale);

      // Opacityを適用するための新しい進捗を計算
      const opacityProgress = Math.min(
        Math.max((progress - opacityProgressStart) / (1.0 - opacityProgressStart), 0),
        1
      );

      // opacity を最大値に制限
      const opacity = Math.min(opacityProgress, opacityMax);
      // CSSカスタムプロパティに設定（例：--overlay-opacity: 0.3）
      aboutImageEl.style.setProperty("--overlay-opacity", opacity);


    });
  };

  /**
   * スクロール時にアニメーション処理を呼び出す
   * requestAnimationFrameでパフォーマンス向上
   */
  const onScroll = () => {
    if (!isScrolling) {
      isScrolling = true;
      window.requestAnimationFrame(() => {
        // オーバーレイの透過度・画像サイズをスクロール位置に応じて更新
        updateOverlayOpacitiesAndScale();
        // 背景画像の位置調整
        updateVisualStates();
        isScrolling = false;
      });
    }
  };

  // 初回実行（スクロールしてなくても状態を設定）
  // オーバーレイの透過度・画像サイズをスクロール位置に応じて更新
  updateOverlayOpacitiesAndScale();
  // 背景画像の位置調整
  updateVisualStates();
  // スクロールイベントを監視
  document.addEventListener("scroll", onScroll);
};

/**
 * 短縮している文章を全文表示
 */
midwest.recruit.showFullText = function() {
  // `read-more`クラスがクリックされたら実行
  $('.js-read-more').on('click', function(){
    // .full-textに.expandedクラスを追加
    $(this).prev('.js-full-text').addClass('expanded');
    // 「続きを読む」を非表示にする
    $(this).hide();
  });
};

/*
 * ========================================
 * 初期処理
 * ========================================
 */
$(function() {

  // ----------------------------------------
  // Common
  // ----------------------------------------    
  // ページ上部のトピックスの表示制御
  if($('.js-header-topics-container').length){
    midwest.common.displayHeaderInformation();
  }

  // メインコンテンツがヘッダーに重なる場合の処理
  if($('.js-transparent-header').length){
    midwest.common.fixContentTop();
  }

  // ハンバーガーメニュー
  if($('.js-hamburger-panel').length){
    // ハンバーガーメニュー内の上部余白調整
    midwest.common.hamburgerMargin();
  }
  
  // トグルのパネル表示
  if($('.js-panel-button').length){
    midwest.common.setupTogglePanel();
  }
  
  // アコーディオンメニュー
  if($('.js-accordion-button').length){
    midwest.common.accordion();
  }

  //「新作」アイコンの表示制御
  if($( '.js-new-icon' ).length){
    // 現在時刻をサーバーから取得
    illm.common.getServerDate().then( date => {
      midwest.common.newicon(date);
    });
  }

  // タブ切り替え
  if($('.js-tab__container').length){
    midwest.common.tabswitch();
  }

  // スクロールインジケーター
  if($('.js-scroll-indicator').length){
    midwest.common.scrollIndicator();
  }


  // ----------------------------------------
  // Top
  // ----------------------------------------
  if ($('.page-index').length) {
    if($('.js-home-visual-swiper').length){
      // ヘッダーの文字色の変更
      midwest.top.controlHeaderColor();
    }

  // ----------------------------------------
  // ItemDetail
  // ----------------------------------------
  } else if ($('.page-product').length) {
    // 商品画像の拡大処理
    if($('.js-product-slider').length){
      midwest.itemDetail.zoomProductImages();
    }

    // サイズの単位切り替え
    if($('.js-size-toggle').length){
      midwest.itemDetail.toggleSizeUnit();
    }

    // 商品ページのRECOMMEND / COLLECTIONのスライダー
    if($('.js-product-recommend-wrapper').length){
      midwest.itemDetail.observeRecommendSlider();
    }

    // 店舗在庫のボタン切り替え
    if($('#store-stock-button').length){
      midwest.itemDetail.updateStoreStockButton();
    }

  // ----------------------------------------
  // Login
  // ----------------------------------------
  } else if ($('.page-login').length) {
    // ログイン後のページ遷移の制御
    if($('.page-login').length){
      midwest.login.handleLoginRedirect();
    }
    
  // ----------------------------------------
  // Contact
  // ----------------------------------------
  } else if ($('.page-contact').length) {
    // 商品情報をお問い合わせフォームにセット
    if($('.js-contact-textarea').length){
      midwest.contact.setFormProductInfo();
    }

  // ----------------------------------------
  // Brand List
  // ----------------------------------------
  } else if ($('.page-brand-list').length) {
    // ブランドリストの絞り込み
    if($('.js-alphabet-nav').length){
      midwest.brandlist.filter();
    }

  // ----------------------------------------
  // ABOUT MIDWEST
  // ----------------------------------------
  } else if ($('.page-about-midwest').length) {
    // スクロール時のアニメーション
    if($('.js-about-visual').length){
      midwest.about.scrollAnimation();
    }

  // ----------------------------------------
  // RECRUIT
  // ----------------------------------------
  } else if ($('.page-recruit').length) {
    // 短縮している文章を全文表示
    if($('.js-read-more').length){
      midwest.recruit.showFullText();
    }
  }
});

$(window).on('load', function() {
  // collection/productのMOVIEスライダー
  if($('.js-subpage-movie-swiper').length){
    midwest.common.movieSlider();
  }

  // ----------------------------------------
  // Top
  // ----------------------------------------
  if ($('.page-index').length) {
    if($('.js-home-visual-swiper').length){
      // メインビジュアルのスライダー
      midwest.top.mainvisual();
    }
    // RECOMMENDのスライダー
    if($('.js-collection-swiper').length){
      midwest.top.collectionSlider();
    }
    
    // ALL / MEN / WOMEN カテゴリの切り替え
    if($('.js-category-nav').length){
      midwest.top.switchCategory();
    }

    // MOVIEのスライダー
    if($('.js-home-movie-swiper').length){
      midwest.top.movieSlider();
    }

  }
});


// 
document.addEventListener('DOMContentLoaded', () => {
  // セッションストレージにカート追加フラグがあれば、カート追加のポップアップを表示
  if (sessionStorage.getItem('addedToCart') === '1') {
    $('cart-notification').show();
    $('#cart-notification').addClass('animate active');
    sessionStorage.removeItem('addedToCart');
  }
  // 商品ページかどうか判定（product-form要素があるかチェック）
  const productForm = document.querySelector('product-form');
  if (productForm) {
    // カート内数量表示の要素を取得
    const target = document.getElementById('cart-icon-bubble');
    if (!target){
      return; // 要素がなければ処理終了
    }

    // 監視開始前の数量を保存
    let previousCount = target.textContent;
    // DOM変化を監視するMutationObserverを作成
    const observer = new MutationObserver(() => {
      // 変化後の数量を取得
      const currentCount = target.textContent;

      // 数量が変わったらリロード
      if (currentCount !== previousCount) {
        previousCount = currentCount;
        // セッションストレージにカート追加フラグを保存
        sessionStorage.setItem('addedToCart', '1');
        // ページリロード（リダイレクトの代わり）
        location.reload();
      }
    });

    // 監視を開始：子ノードの追加削除（childList）とすべての子孫ノード（subtree）を監視
    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }
});
